// src/utility/bridge/constants.js

/**
 * Types allowed from Native → Web (deep-link route)
 */
export const ALLOWLIST_NATIVE_TO_WEB = new Set([
    "PING",
    "OTP_AUTO_FILL",
    "INAPPBROWSER_CLOSED",
]);

/**
 * Types allowed from Web → Native (postMessage)
 * Must match React Native bridge allowlist.
 */
export const ALLOWLIST_WEB_TO_NATIVE = new Set([
    "PING",
    "AUTH_EVENT",
    "NAVIGATE",
    "UTILITY_RECEIPT",
    "HYBRID_PAYMENT",
]);
